import { Component, inject, OnInit } from '@angular/core';
import { map } from 'rxjs';

import { ApContentService } from '@ap/content';
import { MijnOmgevingTemplateService, MijnOmgevingTemplates } from '@ap/mijn-template';
import { ApModalService, ModalOptions, ModalSize } from '@ap/modal';
import { ApPersistenceService } from '@ap/persistence';
import { ApAnalyticsService, ClickAnalyticsData } from '@ap/analytics';
import { KlantbeheerResource } from '@ap/interface-apic-klantbeheer';

import { MijnOmgevingNavigation } from '../mijn-omgeving.navigation';
import {
    ANALYTICS_PHONE_VALIDATION_ACTION_CHANGE,
    ANALYTICS_PHONE_VALIDATION_ACTION_NEW,
    ANALYTICS_PHONE_VALIDATION_ACTION_VALIDATE,
    ANALYTICS_PHONE_VALIDATION_ELEMENT
} from '../mijn-omgeving.constant';

import { PhonenumberValidationMoreInfoModalComponent } from './modal/phonenumber-validation-moreinfo-modal.component';
import content from './phonenumber-validation.content.json';
import { ContactgegevensAction } from './phonenumber-validation.model';
@Component({
    selector: 'phonenumber-validation',
    templateUrl: 'phonenumber-validation.component.html',
    styleUrls: ['./phonenumber-validation.component.scss'],
    standalone: false
})
export class PhoneNumberValidationComponent implements OnInit {
    private readonly analyticsService: ApAnalyticsService = inject(ApAnalyticsService);
    private readonly apContentService: ApContentService = inject(ApContentService);
    private readonly klantBeheerResource: KlantbeheerResource = inject(KlantbeheerResource);
    private readonly mijnOmgevingNavigation: MijnOmgevingNavigation = inject(MijnOmgevingNavigation);
    private readonly mijnOmgevingTemplateService: MijnOmgevingTemplateService = inject(MijnOmgevingTemplateService);
    private readonly modalService: ApModalService = inject(ApModalService);
    private readonly persistenceService: ApPersistenceService = inject(ApPersistenceService);

    public phoneNumber: string;
    public username: string;

    public ngOnInit() {
        this.apContentService.addContentItems(content);

        this.mijnOmgevingTemplateService.setTemplateSettings({
            webcomponentIdentifier: 'phonenumber-validation' as any,
            title: '',
            setTemplate: MijnOmgevingTemplates.EMPTY,
            loading: false
        });
        this.phoneNumber = this.persistenceService.getLocal('telefoonnummer-validatie', 'telefoonnummer');
        this.klantBeheerResource
            .geefIngelogdeKlantDetails()
            .pipe(map((result) => result.combinedName))
            .subscribe((username) => (this.username = username));
    }

    public openMoreInfoModal(): void {
        const modalOptions = new ModalOptions();
        modalOptions.title = this.apContentService.get('mijn-omgeving.phonenumber-validation.more-info.modal-title');
        modalOptions.cancelable = true;
        modalOptions.size = ModalSize.LARGE;
        this.modalService.open(PhonenumberValidationMoreInfoModalComponent, modalOptions);
    }

    public navigateToContactgegevensBeheren(action: 'validate' | 'change' | 'new'): Promise<boolean> {
        if (action === 'validate') {
            this.pushClickEvent(ANALYTICS_PHONE_VALIDATION_ELEMENT, ANALYTICS_PHONE_VALIDATION_ACTION_VALIDATE);
            return this.mijnOmgevingNavigation.toContactgegevensBeheren({
                phonenumber: this.phoneNumber,
                action: ContactgegevensAction.VALIDATE.toLowerCase()
            });
        } else if (action === 'change') {
            this.pushClickEvent(ANALYTICS_PHONE_VALIDATION_ELEMENT, ANALYTICS_PHONE_VALIDATION_ACTION_CHANGE);
            return this.mijnOmgevingNavigation.toContactgegevensBeheren({
                phonenumber: this.phoneNumber,
                action: ContactgegevensAction.CHANGE_PHONE_NUMBER.toLowerCase()
            });
        } else if (action === 'new') {
            this.pushClickEvent(ANALYTICS_PHONE_VALIDATION_ELEMENT, ANALYTICS_PHONE_VALIDATION_ACTION_NEW);
            return this.mijnOmgevingNavigation.toContactgegevensBeheren({ action: ContactgegevensAction.NEW_PHONE_NUMBER.toLowerCase() });
        }
        return this.mijnOmgevingNavigation.toContactgegevensBeheren();
    }

    public getGreeting(): string {
        return `${this.apContentService.get(`mijn-omgeving.phonenumber-validation.greeting.${this.getPartOfDay()}`)} ${this.username}`;
    }

    public getPartOfDay(): string {
        const currentTime = new Date().getHours();

        if (currentTime >= 4 && currentTime < 12) {
            return 'morning';
        } else if (currentTime >= 12 && currentTime < 18) {
            return 'afternoon';
        }
        return 'evening';
    }

    private pushClickEvent(clickedElement: string, clickAction: string): void {
        this.analyticsService.push(new ClickAnalyticsData(clickedElement, clickAction));
    }
}
